import toast from 'react-hot-toast';

import { GET } from "../../API/get";
import { POST } from "../../API/post";
import { DELETE } from '../../API/delete';
import { commonSwal } from '../../components/swalAlert/swalAlert';
import { PUT } from '../../API/put';
import { getUserInfo } from '../../storage';

export const loadData = async (page_number, dispatch) => {
    dispatch({ type: "IS_LOADING" });
    let response = await GET(`admin/users/list/${page_number}`);

    if(response.status === "Success"){
        dispatch({ 
            type: "IS_LOADED",
            total_users: response.total_users,
            total_pages: response.total_pages,
            list: response.list,
            page_number: page_number
        });
    }
}

export const createUser = async (data, dispatch, reset) => {
    dispatch({
        type: 'IS_CREATING_NEW_USER',
        is_creating_new_user: true
    });

    let response = await POST(`create/admin/register`,{
        admin_full_name: data.admin_full_name,
        admin_email: data.admin_email,
        admin_password: data.admin_password,
        admin_role: data.admin_role,
        admin_contact_number: data.admin_contact_number?.replace(/\s+/g, ""),
    });

    if(response.status === "Success"){
        reset();
        loadData(1, dispatch);
    }
}

export const deleteUser = async (admin_id, dispatch) => {
    commonSwal({
        notificationType: 'DELETE_USER',
        preConfirm: async () => {
            let response = await DELETE(`admin/user/${admin_id}`);
            return response;
        },
        isConfirmed: (result) => {
            if (result.isConfirmed) {
                if(result.value.status === "Success"){
                    toast.success(result.value.message);
                    loadData(1, dispatch);
                } else {
                    toast.error(result.value.message);
                }
            }
        }
    })
}

export const editAdmin = async ({ admin_id, admin_full_name, admin_role_id, admin_contact_number }) => {
    const response = await PUT("edit/admin", {
        admin_id: admin_id,
        admin_full_name: admin_full_name,
        admin_role_id: admin_role_id,
        admin_contact_number: admin_contact_number
    });

    return response.status === "Success" ? response : null;
}

export const fetchRoles = async () => {
    const response = await GET('admin/roles/list');

    if (response.status === "Success") {
        const userInfo = getUserInfo();

        // Filter out the roles that the user does not have permission to access
        const filteredRoles = response.roles.filter(role => {
            return userInfo.admin_role_id === 1 || role.role_id === userInfo.admin_role_id;
        });

        return filteredRoles;
    }
    return null;
}